import { render } from "./schools.vue?vue&type=template&id=7ebbaa86&scoped=true"
import script from "./schools.vue?vue&type=script&lang=js"
export * from "./schools.vue?vue&type=script&lang=js"

import "./schools.vue?vue&type=style&index=0&id=7ebbaa86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ebbaa86"]])

export default __exports__